export default {
    // 渠道码
    Code: () => import('@/views/pages/marketing/code.vue'),
    CodeHelp: () => import('@/views/pages/marketing/code_help.vue'),
    // 欢迎语
    Welcome: () => import('@/views/pages/marketing/welcome.vue'),
    // 群发消息
    EnterSend: () => import('@/views/pages/group_send/enterprise_send.vue'),
    StaffSend: () => import('@/views/pages/group_send/staff_send.vue'),
    // 企业朋友圈
    Dynamic: () => import('@/views/pages/wechat_moments/dynamic.vue'),
    // 聊天工具
    Chat: () => import('@/views/pages/chat_tool/chat.vue'),
    WordHelp: () => import('@/views/pages/chat_tool/word_help.vue'),
};